<template>
  <div class="experimental-res">
    <div class="filters">
      <ul-input class="input-search"
        v-model="params.experimentName"
        clearable
        suffix-icon="icon-quanshipei-sousuo"
        @keydown.native.enter="getFirstPage"
        search
        @clear="getFirstPage"
        @search="getFirstPage"
        placeholder="输入关键字搜索"
      ></ul-input>
      <ul-button type="primary" class="button-right" @click="addDialog()">
        {{virtual.type == 2 ? '创建项目' : '添加实验'}}
      </ul-button>
    </div>
    <div class="test-list" v-if="testList.length">
      <div v-for="item in testList" :key="item.id" class="test-item">
        <div class="test-item-left">
          <img :src="item.cover">
          <div class="test-item-info">
            <div class="name">{{ item.title }}</div>
            <div class="time">
              <i class="iconfont icon-shichang1"></i>创建时间：{{ formatDate(Number(item.createTime)) }}
            </div>
          </div>
        </div>
        <div class="test-item-right">
          <ul-dropdown
            @command="handleCommand($event, item)"
          >
            <ul-button class="ul-dropdown-link" size="small" hollow>
              <span class="button-text">编辑</span>
              <i class="iconfont icon-xialacaozuo"></i>
            </ul-button>
            <ul-dropdown-menu slot="dropdown" class="edit-menu">
              <ul-dropdown-item command="a">编辑</ul-dropdown-item>
              <ul-dropdown-item command="b">查看</ul-dropdown-item>
              <ul-dropdown-item command="c">删除</ul-dropdown-item>
            </ul-dropdown-menu>
          </ul-dropdown>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      <img :src="empty">
      {{virtual.type == 2 ? '暂无实训项目' : '暂无实验资源'}}
    </div>
    <ul-pagination
      hide-on-single-page
      class="pagination"
      layout="prev, pager, next, jumper"
      :total="totalNum"
      :page-size.sync="params.ps"
      :current-page.sync="params.pn"
      @current-change="getGradeList"
    ></ul-pagination>

    <ul-dialog
      width="800px"
      :title="virtual.type == 2 ? '创建项目' : '添加实验'"
      class="add-test"
      :visible.sync="dialogVisible"
    >
      <ul-form ref="addTestForm" :model="testForm" :rules="rules" label-width="80px">
        <ul-form-item label="选择实验" prop="tonglabExperimentId"  v-if="virtual.type == 2">
          <label class="uploading" @click="toSelectTonglab">选择实验</label>
          <div class="import-tips">实验内容来源于Tonglab平台，点击自动获取实验信息。</div>
        </ul-form-item>
        <ul-form-item label="实验名称" prop="title">
          <ul-input v-model="testForm.title" placeholder="请输入实验名称"></ul-input>
        </ul-form-item>
        <ul-form-item label="实验封面" prop="cover">
          <label class="uploading" for="avatar">上传封面</label>
          <input
            v-show="false"
            type="file"
            id="avatar"
            style="position: absolute; clip: rect(0 0 0 0)"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="uploadImg($event)"
          />
          <span class="hint">建议尺寸：800*450</span>
          <img class="cover" :src="testForm.cover">
        </ul-form-item>
        <ul-form-item label="实验学时" prop="studytime" v-if="virtual.type != 2">
          <ul-input
            class="score-input"
            v-model="testForm.studytime"
            placeholder="请输入学时"
            type="number"
          />
          <span class="hint">学时</span>
        </ul-form-item>
        <ul-form-item label="实验地址" prop="url"  v-if="virtual.type != 2">
          <ul-input v-model="testForm.url" placeholder="请输入实验地址"></ul-input>
        </ul-form-item>
        <div class="hint-url" v-if="virtual.type != 2">
          注：实验发布之前，请确保实验已按照平台接口规范完成接入，否则系统将无法采集学生实验成绩。
        </div>
        <div class="link" v-if="virtual.type != 2">
          <a :href="require('@/assets/file/virtual.docx')" download="虚拟仿真实验接口规范V1.1.docx">下载平台接口规范文档</a>
        </div>
        <ul-form-item label="实验资源" prop="fileList" v-if="virtual.type == 2">
          <file-list :list="testForm.fileList" @update="createFileUpdate"></file-list>
        </ul-form-item>
      </ul-form>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="addTest">确定</ul-button>
        <ul-button plain @click="dialogVisible = false">取消</ul-button>
      </span>
    </ul-dialog>
    <ul-dialog
      width="800px"
      title="编辑实验"
      class="editing-experiment"
      :visible.sync="editingDialogVisible"
    >
      <div class="select-edit-div">
        <dl>
          <dd @click="selectType(1)" :class="{'select-dd':selectCurrentType==1}">基本信息</dd>
          <dd @click="selectType(2)" v-if="virtual.type != 2" :class="{'select-dd':selectCurrentType==2}">实验介绍</dd>
          <dd @click="selectType(3)" v-if="virtual.type != 2" :class="{'select-dd':selectCurrentType==3}">实验必读</dd>
        </dl>
      </div>
      <div v-if="editingDialogVisible">
        <!-- <component :is="meunMap[selectCurrentType].component" ref="component" :data="componentData"></component> -->
        <info :data="componentData" ref="info" :type="virtual.type" v-show="selectCurrentType == 1"></info>
        <introduce :data="componentData" ref="introduce" v-show="selectCurrentType == 2"></introduce>
        <mustRead :data="componentData" ref="mustRead" v-show="selectCurrentType == 3"></mustRead>
      </div>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="saveExperiment">保存</ul-button>
        <ul-button plain @click="editingDialogVisible = false">取消</ul-button>
      </span>
    </ul-dialog>
    <ul-dialog
      width="800px"
      title="选择实验"
      class="tonglab-experiments"
      :visible.sync="tonglabDialogVisible"
    >
      <div class="experiments-container">
        <div class="experiments-header">
          <ul-input class="input-search"
            v-model="tonglabParams.keyword"
            clearable
            search
            suffix-icon="icon-quanshipei-sousuo"
            @keydown.native.enter="searchTonglabExperiments"
            @clear="searchTonglabExperiments"
            @search="searchTonglabExperiments"
            placeholder="输入关键字搜索"
          ></ul-input>
        </div>
        <div class="experiments-body">
          <ul-scrollbar
            tag="div"
            ref="scrollbar"
            class="scrollbar-body"
            wrapStyle="max-height:450px;overflow-x:auto;"
            >
            <ul class="experiment-list">
              <li v-for="item in tonglabExperimentList" :key="item.experimentId">
                <div class="cover">
                  <img :src="item.coverImage" alt="">
                </div>
                <div class="info">
                  <div class="name">{{ item.experimentName }}</div>
                  <div class="desc"></div>
                </div>
                <div class="action">
                  <ul-button v-if="selectedTonglabExperiment.experimentId != item.experimentId" hollow size="small" @click="selectedTonglabExperiment = item">选择</ul-button>
                  <ul-button v-else type="primary" size="small" @click="selectedTonglabExperiment = item.experimentId">选择</ul-button>
                </div>
              </li>
            </ul>
            <ul-pagination
              hide-on-single-page
              class="pagination"
              layout="prev, pager, next, jumper"
              :total="tonglabTotal"
              :page-size.sync="tonglabParams.pageSize"
              :current-page.sync="tonglabParams.page"
              @current-change="getTonglabExperiments"
            ></ul-pagination>
          </ul-scrollbar>
          
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="importTonglabInfo">确定</ul-button>
        <ul-button plain @click="tonglabDialogVisible = false">取消</ul-button>
      </span>
    </ul-dialog>
    <cropper ref="cropperDialog" @upData="upDataPicurl"></cropper>
  </div>
</template>

<script>
import { formatDate } from '@/utils'
import info from './components/info.vue'
import introduce from './components/introduce.vue'
import mustRead from './components/mustRead.vue'
import cropper from '../components/cropper.vue'
import empty from '@/assets/images/empty1.png'
import fileList from './components/fileList.vue'
import { mapGetters } from "vuex";
import { TONGLAB_WEB_HOST } from '@/config'
import {
  saveExperiment,
  getCourseExperimentList,
  deleteExperiment,
  updateExperiment,
  getExperimentInfo,
  getTonglabExperiments,
  transferTonglabExperiment,
  getTonglabTicket
} from '@/api/courseApi/virtual.js'
export default {
  components: {
    info,
    introduce,
    mustRead,
    cropper,
    fileList
  },
  computed: {
    ...mapGetters("virtual", { virtual: "virtual" }),
  },
  data() {
    return {
      empty,
      totalNum: 0,
      params: {
        courseId : this.$route.params.id,
        experimentName: '',
        pn: 1,
        ps: 20,
      },
      formatDate,
      testForm: {
        courseId : this.$route.params.id,
        title: '',
        cover: '',
        studytime: '',
        url: ''
      },
      rules: {
        tonglabExperimentId: [
          { required: true, message: '请选择实验', trigger:"change" },
        ],
        title: [
          { required: true, message: '请输入实验名称', trigger:"blur" },
        ],
        cover: [
          { required: true, message: '请上传封面', trigger:"change" },
        ],
        studytime: [
          { required: true, message: '请输入学时', trigger:"blur" },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur'}
        ],
        url: [
          { required: true, message: '请输入实验地址', trigger:"blur" },
        ]
      },
      dialogVisible: false,
      testList: [],
      editingDialogVisible: false,
      selectCurrentType: 1,
      componentData: null,
      tonglabDialogVisible: false,
      tonglabTotal: 0,
      tonglabExperimentList: [],
      tonglabParams: {
        keyword: '',
        page: 1,
        pageSize: 10,
      },
      selectedTonglabExperiment: ''
    }
  },
  created() {
    this.getExperimentList()
  },
  methods: {
    getExperimentList() {
      getCourseExperimentList(this.params)
      .then((res)=>{
        this.testList = res.list
        this.totalNum = res.total
      })
    },
    uploadImg(e) {
      let data = {
        title: '上传封面'
      }
      this.$refs.cropperDialog.uploadImg(e, data)
    },
    upDataPicurl(url) {
      this.testForm.cover = url
    },
    selectType(type) {
      this.selectCurrentType = type
    },
    saveExperiment() {
      let introduce = this.$refs.introduce
      let mustRead = this.$refs.mustRead

      if (!introduce.validate()) {
        this.selectType(2)
        return
      }

      if (!mustRead.validate()) {
        this.selectType(3)
        return
      }

      this.$refs.info.$refs.editForm.validate((valid)=>{
        if (valid) {
          let data = {
            id: this.componentData.id,
            title: this.componentData.title,
            cover: this.componentData.cover,
            studytime: this.componentData.studytime,
            url: this.componentData.url,
            fileList: this.componentData.fileList,
            teachTarget: introduce.list[0].content,
            principle: introduce.list[1].content,
            processAndMethod: introduce.list[2].content,
            step: introduce.list[3].content,
            resultAndConclusion: introduce.list[4].content,
            networkRequire: mustRead.list[0].content,
            hardwareRequire: mustRead.list[1].content,
            operateSystemRequire: mustRead.list[2].content,
          }

          updateExperiment(data)
          .then(()=>{
            this.editingDialogVisible = false
            this.getExperimentList()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
          })
        } else {
          this.selectType(1)
        }
      })
    },
    handleCommand(e, item) {
      switch (e) {
        case 'a':
          this.edit(item)
          break;
        case 'b':
          this.look(item)
          break;
        case 'c':
          this.delTest(item)
          break;
        default:
          break;
      }
    },
    edit(item) {
      getExperimentInfo({experimentId: item.id})
      .then(({result}) => {
        result.fileList = result.fileList || []
        this.componentData = result
        this.selectCurrentType = 1
        this.editingDialogVisible = true
      })
    },
    look(item) {
      if (this.virtual.type == 2) {
        if (item.url) {
          window.open(item.url)
        } else {
          getTonglabTicket()
            .then(({result}) => {
              let url = `${TONGLAB_WEB_HOST}/#/nolayout-wenhua/teach-guide?courseId=${item.tonglabExperimentId}&ticket=${result}`
              window.open(url)
            })
        }
      } else {
        window.open(`#/virtual/experimentPage/${item.id}`)
      }
    },
    delTest(item) {
      if (item.whetherIntroduce == 1) {
        this.$message({
          message: '实验资源已被班课引用，无法删除。',
          type: 'error'
        })
      } else {
        this.$confirm('确定删除吗？','删除')
        .then(()=>{
          deleteExperiment(item.id)
          .then(()=>{
            this.getExperimentList()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          })
          .catch(err => {
            this.$message({
              message: '实验资源已被班课引用，无法删除。',
              type: 'error'
            })
          })
        })
      }
    },
    addDialog() {
      this.testForm = {
        courseId : this.$route.params.id,
        title: '',
        cover: '',
        studytime: '',
        type: this.virtual.type,
        url: '',
        fileList: [],
        tonglabExperimentId: ''
      }
      this.dialogVisible = true
      this.$nextTick(()=>{
        this.$refs.addTestForm.clearValidate()
      })
    },
    createFileUpdate (list) {
      this.testForm.fileList = list
    },
    addTest() {
      this.$refs.addTestForm.validate((valid)=>{
        if (valid) {
          saveExperiment(this.testForm)
          .then(()=>{
            this.getExperimentList()
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.dialogVisible = false
          })
        }
      })
    },
    getFirstPage() {
      this.params.pn = 1
      this.getExperimentList()
    },
    getGradeList(val) {
      this.params.pn = val
      this.getExperimentList()
    },
    toSelectTonglab () {
      this.tonglabDialogVisible = true
      this.tonglabParams.keyword = ''
      this.tonglabParams.page = 1
      this.getTonglabExperiments()
    },
    searchTonglabExperiments () {
      this.tonglabParams.page = 1
      this.getTonglabExperiments()
    },  
    getTonglabExperiments () {
      getTonglabExperiments(this.tonglabParams)
        .then(({result})=>{
          this.tonglabExperimentList = result.list
          this.tonglabTotal = result.total
        })
    },
    importTonglabInfo () {
      let loading = this.$loading({
        lock: true,
        text: '正在导入实验数据...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      transferTonglabExperiment(this.selectedTonglabExperiment.experimentId, { transferCover: true, transferResources: true })
        .then(({result})=>{
          this.testForm.title = result.experimentName
          this.testForm.cover = result.coverImage
          this.testForm.url = result.accessUrl
          this.testForm.tonglabExperimentId = result.experimentId
          this.testForm.platformId = 1000003
          this.testForm.fileList = result.resources.map(item => {
            return {
              fileName: item.resourceName,
              fileUrl: item.resourceUrl
            }
          })
          loading.close()
          this.tonglabDialogVisible = false
        })
        .catch(() => {
          this.$message({
            message: '导入失败',
            type: 'error'
          })
          loading.close()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.experimental-res {
  padding-top: 24px;
  .filters {
    margin-bottom: 20px;
    .input-search{
      width: 200px;
    }
    .button-right {
      float: right;
    }
  }
  .test-list {
    .test-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px 0;
      border-top: 1px dashed #E3E3E9;
      .test-item-left {
        display: flex;
        img {
          width: 96px;
          height: 54px;
          margin-right: 16px;
        }
        .test-item-info {
          .name {
            font-size: 16px;
            line-height: 1.5;
            margin-bottom: 10px;
          }
          .time {
            color: #969696;
            display: flex;
            align-items: center;
            i {
              font-size: 14px;
              margin-right: 4px;
            }
          }
        }
      }
      .test-item-right {
        .ul-dropdown-link {
          padding: 6px 10px;
          .button-text {
            margin-right: 18px;
            line-height: 18px;
            display: inline-block;
            text-align: left;
          }
          .icon-xialacaozuo {
            font-size: 12px;
            transform: scale(0.7);
            display: inline-block;
          }
        }
      }
    }
  }
  .empty {
    display: flex;
    align-items: center;
    flex-direction: column;
    img {
      width: 190px;
      margin-bottom: 16px;
    }
    text-align: center;
    margin-top: 120px;
    color: #969696;
  }
}
::v-deep{
  .editing-experiment .ul-dialog__body{
    min-height: 416px;
    max-height: 796px;
  }
}
.add-test {
  .score-input {
    width: 110px;
    margin-right: 10px;
  }
  .import-tips{
    color: $--color-text-secondary;
    line-height: 1;
    font-size: 12px;
  }
  .hint {
    color: $--color-text-secondary;
  }
  .hint-url {
    color: $--color-text-secondary;
    font-size: 12px;
    line-height: 1.5;
    margin: 10px 0;
    padding-left: 80px;
  }
  .link {
    color: #8D77FB;
    cursor: pointer;
    font-size: 12px;
    line-height: 1.5;
    padding-left: 80px;
  }
  .uploading {
    color: #8D77FB;
    cursor: pointer;
    margin-right: 12px;
  }
  img {
    display: block;
    width: 120px;
  }
}

::v-deep.editing-experiment {
  .ul-dialog__body {
    // height: 497px;
  } 
  .select-edit-div {
    margin: 0;
    margin-bottom: 14px;
    color: #444;
    font-size: 14px;
    .select-dd {
      color: #ea5947;
      border-bottom: 2px solid #ea5947;
      
    }
    dl {
      display: flex;
      width: 100%;
      border-bottom: 1px solid #E3E3E9;
      dd {
        padding: 5px 10px;
        cursor: pointer;
        margin-right: 4px;
      }
    }
    dl,
    dd {
      margin: 0;
    }
  }
}
.pagination {
  display: flex;
  margin-top: 14px;
  justify-content: center
}
.edit-menu {
  width: 80px;
}
.tonglab-experiments{
  .experiments-container{
    margin: 0 -15px;
  }
  .experiments-header{
    padding: 0 15px;
  }
  .input-search{
    width: 200px;
  }
  .experiments-body{
    height: 450px;
    .ul-pagination{
      margin-bottom: 20px;
    }
  }
  .experiment-list{
    margin: 20px 0;
    padding: 0 15px;
    li{
      display: flex;
      border: $--border-base;
      padding: 12px 16px;
      border-radius: 4px;
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
    .cover{
      font-size: 0;
      img{
        height: 63px;
        width: 112px;
      }
    }
    .info{
      margin: 0 12px;
      flex: 1;
      .name{
        @include ellipsis;
      }
      .desc{
        margin-top: 6px;
        color: $--color-text-secondary;
        font-size: 12px;
        line-height: 1.5;
        @include ellipsis2;
      }
    }
    .action{
      display: flex;
      align-items: center;
    }
  }
}
</style>